import React from "react";
import "./header.scss";
import { hapticSelect } from "../../utils/haptic";

export default class Header extends React.Component<any, any> {
  render() {
    return <header className={"header"}>
      <div className={"headerim__brand"}>
        <div className={"header__logo"}>
          <span className={"header__logo-icon"}>1.5</span>
        </div>
        <div className={"header__title-group"}>
          <h1>Переговорка</h1>
          <span className={"header__version"}>1.5</span>
        </div>
      </div>
      <button
        className={"header__logout"}
        onClick={() => {
          hapticSelect();
          localStorage.removeItem("csrf");
          localStorage.removeItem("jwt");
          document.location.reload();
        }
      }>
        <span className={"header__logout-text"}>Выйти</span>
        <span className={"header__logout-icon"}>→</span>
      </button>
    </header>;
  }
}